<div class="border-b border-gray-200">
    <nav class="-mb-px flex space-x-4 sm:space-x-8 overflow-x-auto">
        <button
            (click)='selectedIndex = i'
            [ngClass]='{
             "border-primary-500 text-primary-600": selectedIndex === i,
             "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300": selectedIndex !== i
            }'
            class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm"
            *ngFor="let tab of tabs; index as i"
        >
            {{ tab.title | titlecase }}
        </button>
    </nav>
</div>
<ng-container *ngFor='let tab of tabs; index as i'>
    <ng-container *ngIf='selectedIndex === i'>
    <ng-container *ngTemplateOutlet='tab.templateRef'></ng-container>
    </ng-container>
</ng-container>
